module.exports = __webpack_public_path__ + "img/01George.fbdb7069.png";